import axios from 'axios'
import type {
  INotificationSettingSync,
  INotificationSettingsPreset,
} from '../types/notificationSettings.types'
import { BASE_URL } from '@/environment/environment'

/**
 * Сервис настроек уведомлений.
 *
 * Бек API (по swagger /api/schema/notifications/):
 * - GET /api/notifications/settings/preset/ — вложенный объект {settings: {канал: {тип: bool}}}.
 *   Бек присылает только пары канал-тип, валидные для пользователя.
 * - PUT /api/notifications/settings/sync/  — на вход плоский массив пар (включая флаг
 *   is_enabled на каждой), бек возвращает обновлённый preset той же формы что get.
 */
export const notificationSettingsApi = {
  /** GET /api/notifications/settings/preset/ */
  getPreset() {
    return axios.get<INotificationSettingsPreset>(`${BASE_URL}/api/notifications/settings/preset/`)
  },

  /** PUT /api/notifications/settings/sync/ — массив пар. */
  syncSettings(pairs: INotificationSettingSync[]) {
    return axios.put<INotificationSettingsPreset>(
      `${BASE_URL}/api/notifications/settings/sync/`,
      pairs,
    )
  },
}
